import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Check if already logged in
  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem('admin-login');
    if (isLoggedIn) {
      navigate('/'); // Redirect to home if already logged in
    }
  }, [navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Hard-coded admin credentials
    const adminEmail = 'admin@gmail.com';
    const adminPassword = 'admin123';
    
    if (email === adminEmail && password === adminPassword) {
      // Set session storage
      sessionStorage.setItem('admin-login', 'true');
      // Redirect to home page
      navigate('/dashboard/create-blogs');
    } else {
      setError('Invalid email or password');
      setTimeout(() => {
        setError('');
      }, 3000);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-modal">
        <div className="admin-login-header">
          <h2>Admin Login</h2>
        </div>
        
        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && <div className="admin-login-error">{error}</div>}
          
          <div className="admin-login-input-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>
          
          <div className="admin-login-input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>
          
          <button type="submit" className="admin-login-button">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
